import { moneyFormat } from "@redotech/money/util";
import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getShippingMargin } from "../shipping/margin-breakdown";

export const ShippingMarginCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Shipping margin",
    cell: (row) => {
      const margin = getShippingMargin(row);
      return margin ? moneyFormat(margin) : "-";
    },
  };
